import Image_Default from "../../images/man.png";
import Button_More from "../main/Button_More";
import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {connect} from "react-redux";

const Tweet = (props) => {
    const {content,date,user_id} = props;
    const [user,setUser] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        try {
            getUser(user_id);
        } catch (error) {
            console.log(error);
        }
    },[]);
    const getUser = (id) => {
        fetch(`/user?q=${id}`)
        .then(res => res.json())
        .then(data => {
            setUser(data[0])
        })
        .catch(error => console.log(error))
    };
    const handleImageClick = () => {
        if (user_id == props.user.id) {
            navigate("/profile")
        } else {
            navigate(`/profile/${user_id}`)
        }
    };
    const handleNameClick = () => {
        if (user_id == props.user.id) {
            navigate("/profile")
        } else {
            navigate(`/profile/${user_id}`)
        }
    };
    return(
        <div className={`home_tweet_div background_change_hover background_change_hover_${props.color_background}`}>
            <img onClick={handleImageClick} src={Image_Default} alt="User" className="user_image user_image_tweet" />
            <div className="home_tweet_main">
                <div className="home_tweet_info">
                    <div onClick={handleNameClick} className="home_tweet_name name">{user.firstName}</div>
                    <div className="home_tweet_username home_tweet_head_info">@{user.userName}</div>
                    <div className="home_tweet_date home_tweet_head_info">{date}</div>
                </div>
                <div className="home_tweet_content">{content}</div>
            </div>
            <Button_More />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background,
        user: state.getUser.user
    }
}
export default connect(mapStateToProps)(Tweet);